// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"6901e330","312":"2fa50d85","375":"e3b5b295","455":"98cc1df4","638":"f84087f9","796":"86b4591f","842":"e7f84f89","977":"6a7f6471"}[chunkId] + ".chunk.js";
};